module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11719/img/callout-wave.svg"